import * as actionTypes from './actionTypes';
import axios from "../../axios";
import {prepareQualifyVehicleQuestions, setSelectedVehicleIndex} from './index';
import { copyObject } from '../../shared/utility';
import { pushVehicleImageByLink } from '../../shared/vehicle';

export const createVehicle = (data) => {
    return async (dispatch, getState) => {
        const token = getState().auth.token.id_token;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
        delete data.uid;
        const res = await axios.post(`vehicles`, data, {headers: headers})
        if (res.status === 200) {
            
        }
    };
};

export const getVehicle = (id) => {
    return async (dispatch, getState) => {
        const token = getState().auth.token.id_token;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer' + token
        }
        const res = await axios.get(`vehicles/{id}`, {headers: headers})
        if (res.status === 200) {
            dispatch({data: res.data, type: actionTypes.LOAD_VEHICLE})
        }
    }
};


export const getVehicles = (cb) => {
    return async (dispatch, getState) => {
        if (getState().auth.isAuthenticated) {
            const token = getState().auth.token.id_token;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
            try {
                const res = await axios.get(`vehicles?expand=offers,appointments`, {headers: headers});
                console.log('res', res);
                if (res.status === 200) {
                    const items = Array.isArray(res.data) ? res.data : [];
                    dispatch({data: items, type: actionTypes.LOAD_VEHICLE})
                    let selectedVehicleIndex = getState().app.selectedVehicleIndex;
                    selectedVehicleIndex = items.length > selectedVehicleIndex && items[selectedVehicleIndex] ? selectedVehicleIndex : 0;
                    dispatch(setSelectedVehicleIndex(selectedVehicleIndex, res.data))
                    //dispatch({index: 0, type: actionTypes.SET_APP_SELECTED_VEHICLE})
                }
                cb && cb(null, res);
            } catch(err) {
                cb && cb(err, null);
            }
        }
    }
};

export const addVehicle = (data, nextStep) => {
    return (dispatch, getState) => {
        const state = getState();
        dispatch(createVehicle(state.newVehicle))
        dispatch({
            data: state.newVehicle,
            type: actionTypes.ADD_VEHICLE,
        });
    }
};

export const uploadVehiclePhoto = (req, cb) => {
    
    return async dispatch => {
        const res = await axios.put(`vehicles/${req.id}/upload`, req, null);
        const data = res.data;
        const isSuccess = res.status === 200 && (data && !data.errors);
        const err = isSuccess ? null : (data ? data.errors : 'unknown error');
        cb && cb(err, data);
        console.log('res', res);
        //dispatch(saveVehiclePhoto({ key: req.key, url: data.url, vehicle_id: req.id }));
    }
}

// deprecated
export const saveVehiclePhoto = (data) => {
    return async (dispatch, getState) => {
        const state = getState()
        const index = state.vehicles.findIndex(x => x.id === data.vehicle_id)

        const updatedState = copyObject(state.vehicles);
        pushVehicleImageByLink(updatedState[index], data.url, data.key);
        dispatch({
            data: {vehicles: updatedState},
            type: actionTypes.SAVE_VEHICLES
        })
    };
};

export const updateVehicleInList = (vehicle) => {
    return async (dispatch, getState) => {
        const state = getState()
        const idx = state.vehicles.findIndex(x => +x.id === +vehicle.id)
        const updatedState = copyObject(state.vehicles);
        idx > -1 ?
            updatedState[idx] = vehicle :
            updatedState.push(vehicle);

        dispatch({
            data: {vehicles: updatedState},
            type: actionTypes.SAVE_VEHICLES
        })
    };
}

export const saveVehicle = (id, data, nextStep) => {
    return async (dispatch, getState) => {
        const token = getState().auth.token.id_token;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
        if (data.hasOwnProperty('mileage')) {
            data.mileage = Number(data.mileage);
        }
        const res = await axios.put('vehicles/' + id, data, {headers: headers})
        if (res.status === 200) {
            dispatch(getVehicles())
        }
    }
};
